import { useState } from "react"
import EIDService from "../services/api"

export const useEID = () => {

    const [isLoadingGetEIDListByUser, setIsLoadingGetEIDListByUser] = useState(false)
    const [eids, setEIDs] = useState(null)
    const [errorGetEIDListByUser, setErrorGetEIDListByUser] = useState(null)

    const [isLoadingGenerateEID, setIsLoadingGenerateEID] = useState(false)
    const [generatedEID, setGeneratedEID] = useState(null)
    const [errorGenerateEID, setErrorGenerateEID] = useState(null)

    const [isLoadingViewEID, setIsLoadingViewEID] = useState(false)
    const [eid, setEID] = useState(null)
    const [errorViewEID, setErrorViewEID] = useState(null)

    const [isLoadingGetEIDInfoQRCode, setIsLoadingGetEIDInfoQRCode] = useState(false)
    const [eidInfQRCode, setEIDInfQRCode] = useState(null)
    const [errorGetEIDInfoQRCode, setErrorGetEIDInfoQRCode] = useState(null)

    const [isLoadingShareEID, setIsLoadingShareEID] = useState(false)
    const [sharedEID, setSharedEID] = useState(null)
    const [errorShareEID, setErrorShareEID] = useState(null)

    const [isLoadingUpdateEIDStatus, setIsLoadingUpdateEIDStatus] = useState(false)
    const [udpatedEIDStatus, setUdpatedEIDStatus] = useState(null)
    const [errorUpdateEIDStatus, setErrorUpdateEIDStatus] = useState(null)

    const getEIDListByUser = (user_uid) => {
        setIsLoadingGetEIDListByUser(true)
        setEIDs(null)
        setErrorGetEIDListByUser(null)
        EIDService.getEIDListByUser(user_uid).then((res) => {
            setIsLoadingGetEIDListByUser(false)
            if (res.data.success) {
                setEIDs(res.data.data)
            } else {
                setErrorGetEIDListByUser(res.data.error)
            }
        })
        .catch((e) => {
            setIsLoadingGetEIDListByUser(false)
            setErrorGetEIDListByUser(e.response?.data)
        })
    }

    const generateEID = (profile_uid) => {
        setIsLoadingGenerateEID(true)
        setGeneratedEID(null)
        setErrorGenerateEID(null)
        EIDService.generateEID(profile_uid).then((res) => {
            setIsLoadingGenerateEID(false)
            if (res.data.success) {
                setErrorGenerateEID(res.data.data)
            } else {
                setErrorGenerateEID(res.data.error)
            }
        })
        .catch((e) => {
            setIsLoadingGenerateEID(false)
            setErrorGenerateEID(e.response?.data)
        })
    }

    const viewEID = (profile_uid) => {
        setIsLoadingViewEID(true)
        setEID(null)
        setErrorViewEID(null)
        EIDService.viewEID(profile_uid).then((res) => {
            setIsLoadingViewEID(false)
            if (res.data.success) {
                setEID(res.data.data)
            } else {
                setErrorViewEID(res.data.error)
            }
        })
        .catch((e) => {
            setIsLoadingViewEID(false)
            setErrorViewEID(e.response?.data)
        })
    }

    const getEIDInfoQRCode = () => {
        setIsLoadingGetEIDInfoQRCode(true)
        setEIDInfQRCode(null)
        setErrorGetEIDInfoQRCode(null)
        EIDService.getEIDInfoQRCode().then((res) => {
            setIsLoadingGetEIDInfoQRCode(false)
            if (res.data.success) {
                setEIDInfQRCode(res.data.data)
            } else {
                setErrorGetEIDInfoQRCode(res.data.error)
            }
        })
        .catch((e) => {
            setIsLoadingGetEIDInfoQRCode(false)
            setErrorGetEIDInfoQRCode(e.response?.data)
        })
    }

    const shareEID = (fields) => {
        setIsLoadingShareEID(true)
        setSharedEID(null)
        setErrorShareEID(null)
        EIDService.shareEID(fields).then((res) => {
            setIsLoadingShareEID(false)
            if (res.data.success) {
                setSharedEID(res.data.data)
            } else {
                setErrorShareEID(res.data.error)
            }
        })
        .catch((e) => {
            setIsLoadingShareEID(false)
            setErrorGetEIDListByUser(e.response?.data)
        })
    }

    const updateEIDStatus = (uuid, status) => {
        setIsLoadingUpdateEIDStatus(true)
        setUdpatedEIDStatus(null)
        setErrorUpdateEIDStatus(null)
        EIDService.updateEIDStatus(uuid, status).then((res) => {
            setIsLoadingUpdateEIDStatus(false)
            if (res.data.success) {
                setEIDs(res.data.data)
            } else {
                setErrorUpdateEIDStatus(res.data.error)
            }
        })
        .catch((e) => {
            setIsLoadingUpdateEIDStatus(false)
            setErrorUpdateEIDStatus(e.response?.data)
        })
    }

    return {
        isLoadingGetEIDListByUser,
        eids,
        errorGetEIDListByUser,
        getEIDListByUser,

        isLoadingGenerateEID,
        generatedEID,
        errorGenerateEID,
        generateEID,

        isLoadingViewEID,
        eid,
        errorViewEID,
        viewEID,

        isLoadingGetEIDInfoQRCode,
        eidInfQRCode,
        errorGetEIDInfoQRCode,
        getEIDInfoQRCode,

        isLoadingShareEID,
        sharedEID,
        errorShareEID,
        shareEID,

        isLoadingUpdateEIDStatus,
        udpatedEIDStatus,
        errorUpdateEIDStatus,
        updateEIDStatus,
    }
}
